import { useViewContext } from '@apps/createWedding/components/View';

export const useProgressBarController = () => {
  const { currentView } = useViewContext();

  let hidden = false;
  let filled = 0;

  switch (currentView) {
    case 'createAccount':
    case 'signIn':
    case 'forgotPassword':
      filled = 0.33;
      break;
    case 'createWeddingForm':
      filled = 0.66;
      break;
    case 'weddingAlreadyExists':
      hidden = true;
      break;
    case 'questionnaire':
      filled = 1;
  }

  return { hidden, filled };
};
